import { ROUTES } from '@/constants'

export const CHAIRPERSON_RETURN_TO = {
  SCHEDULE: 'schedule',
}

export const pickChairpersonDriveNavState = (state = {}) => ({
  returnTo: state?.returnTo,
  fromTab: state?.fromTab,
  driveName: state?.driveName,
  driveDate: state?.driveDate,
  accountId: state?.accountId,
})

export const getChairpersonDriveBackTarget = ({
  returnTo,
  fromTab = 'upcoming',
  driveId,
} = {}) => {
  if (returnTo === CHAIRPERSON_RETURN_TO.SCHEDULE && driveId != null) {
    return {
      label: 'Back to Schedule',
      to: ROUTES.CHAIRPERSON_SCHEDULE_DRIVE.replace(
        ':driveId',
        String(driveId)
      ),
    }
  }

  const isPast = fromTab === 'past'
  return {
    label: isPast ? 'Back to Past Drives' : 'Back to Upcoming Drives',
    to: ROUTES.CHAIRPERSON_DASHBOARD,
    state: { tab: isPast ? 'past' : 'upcoming' },
  }
}
